import { Http, CustomRequestConfig } from '@/lib/http';

import {
  GetBillDetailQuery,
  GetBillDetailRes,
  GetBillTrHistoryQuery,
  GetBillTrHistoryRes
} from './settlementBill.type';

export const API_URL = {
  /* 商户端调整单详情 */
  GetBillDetailURL: '/web/settlement/getBillDetail',
  /* 历史账单追溯 */
  GetBillTrHistoryURL: '/web/settlement/getBillTrHistory'
};

export class SettlementBillApiModule {
  /**
   * 商户端调整单详情
   * @link 接口文档 https://xmock.intra.xiaojukeji.com/project/7211/interface/api/1024004
   * @updateTime 5/7/2025, 2:50:02 PM
   */
  static getGetBillDetail(params: GetBillDetailQuery, exParams?: CustomRequestConfig) {
    return Http<GetBillDetailRes>({
      method: 'GET',
      url: API_URL.GetBillDetailURL,
      params,
      ...exParams
    });
  }

  /**
   * 历史账单追溯
   * @link 接口文档 https://xmock.intra.xiaojukeji.com/project/7211/interface/api/1024051
   * @updateTime 5/7/2025, 3:46:55 PM
   */
  static getGetBillTrHistory(params: GetBillTrHistoryQuery, exParams?: CustomRequestConfig) {
    return Http<GetBillTrHistoryRes>({
      method: 'GET',
      url: API_URL.GetBillTrHistoryURL,
      params,
      ...exParams
    });
  }
}

export default SettlementBillApiModule;
